/**
 * @flow
 */

import Img from "gatsby-image"
import _ from "lodash"
import React, { useCallback, useContext, useLayoutEffect, useRef } from "react"
import styled from "styled-components"

import { ScrollerContext } from "../elements/SmoothScroll/context"

type Props = {
  img: Object,
  maxWidth: number,
  maxHeight: number,
}

const Container = styled.div`
  max-width: ${props => `${props.maxWidth}px`};
  max-height: ${props => `${props.maxHeight}px`};
  .gatsby-image-wrapper {
    img {
      transition: all 1000ms ease 0s !important;
      transform-origin: top;
      transform: scaleY(1.15);
    }
  }
  &.active {
    .gatsby-image-wrapper {
      img {
        transform: scaleY(1);
      }
    }
  }
`

const Photo = ({ img, ...props }: Props) => {
  const context = useContext(ScrollerContext)

  const frameId = useRef(null)
  const containerEl = useRef(null)

  const onScroll = useCallback(() => {
    let target = _.get(containerEl, "current").getBoundingClientRect().top
    let upperbound = window.innerHeight

    /* add class to img element once in active zone */
    if (target < upperbound - upperbound / 4) {
      if (!_.get(containerEl, "current").classList.contains(`active`)) {
        _.get(containerEl, "current").classList.add(`active`)
      }
    } else {
      if (_.get(containerEl, "current").classList.contains(`active`)) {
        _.get(containerEl, "current").classList.remove(`active`)
      }
    }

    /* recall RAF whilst scrolling is still taking place */
    if (frameId.current && context.isScrolling) {
      frameId.current = window.requestAnimationFrame(onScroll)
    }
  }, [context.isScrolling])

  useLayoutEffect(() => {
    if (context.isScrolling || !frameId.current) {
      frameId.current = window.requestAnimationFrame(onScroll)
    } else {
      window.cancelAnimationFrame(frameId.current)
    }
  }, [context.isScrolling, onScroll])

  return (
    <Container ref={containerEl} {...props}>
      <Img fluid={img.childImageSharp.fluid} alt="Teamgeek 2019" />
    </Container>
  )
}

export default Photo
